export const fuelSign = (shipper) => {
    if (['GLS'].includes(shipper.shortcut.toUpperCase())) {
        return '€';
    }
    return '%';
}